import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=2fb6843f"
import script from "../script.ts?vue&type=script&lang=ts&external"
export * from "../script.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports